import { ReactNode } from 'react';

import { Box, Typography } from '@mui/material';

export type LabeledTextSize = 'xs' | 'sm' | 'md' | 'lg';

const labelFontSizes: Record<LabeledTextSize, number> = {
    xs: 8,
    sm: 10,
    md: 11,
    lg: 12,
};

export type LabeledTextProps = {
    value: ReactNode;
    label?: ReactNode;
    color?: string;
    size?: LabeledTextSize;
};

export function LabeledText({ value, label, color, size = 'md' }: LabeledTextProps) {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.4 }}>
            {label && (
                <Typography
                    sx={{
                        fontSize: labelFontSizes[size],
                        fontWeight: 700,
                        textTransform: 'uppercase',
                        letterSpacing: 0.5,
                        lineHeight: 1,
                        color: color || 'primary.main',
                    }}
                >
                    {label}
                </Typography>
            )}

            <Box sx={{ display: 'inline-flex', alignItems: 'flex-end' }}>{value}</Box>
        </Box>
    );
}
